export default __webpack_public_path__ + "static/media/gift.477b4583.svg";